import { AfterViewInit, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'app-snackbar',
    templateUrl: './snackbar.component.html',
    styleUrls: ['./snackbar.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SnackbarComponent implements OnChanges {
  @Input() public show: boolean;
  @Input() public manualClose: boolean;
  @Input() public message: string;
  @Input() public messageExtension: {};
  @Input() public color: string = 'primary';
  @Input() public title: string;

  @Output() public close = new EventEmitter();

  constructor(private sanitizer: DomSanitizer) {
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.message && changes.message.currentValue) {
      this.message = this.sanitizer.bypassSecurityTrustHtml(changes.message.currentValue).toString();
    }
  }
}
